import styled from "styled-components";

export const Title = styled.h1`
    color: ${ props => props.theme.colors.brand1.pure};
    text-transform: uppercase;
    font-weight: normal;
    font-size: 1.8rem;

    &.title{
        margin-top: 70px;
        margin-bottom: 50px;
        text-align: center;
        color: #DBC7B8;
        text-transform: uppercase;    
        font-size: 2rem;
    }

    @media(min-width:480px) {
        font-size: 2rem;
    }

    @media(min-width:768px) {
        font-size: 1.25rem;
        line-height: 25px;
    }  
`